export const CLASS_NAMES = {
  baseContainer: 'flex flex-col flex-1 relative',
  paddingContainer: 'flex flex-col flex-1 p-2',
  content: 'flex flex-col flex-1',
  link: 'flex flex-1 flex-row',
  seperatorWrapper: 'flex flex-1 flex-row -mx-2 my-1',
  seperator: 'bg-neutral-100 w-full h-px',
};
